export default {
  today: 'Dzisiaj',
  tomorrow: 'Jutro',
};
